export const online = (state) => state.online

export const isApiKeyValid = (state) => state.isApiKeyValid
